import React from 'react';

import Button from 'app/components/Button';

const ContactButton = () => <Button to="mailto:iperformacademy@hotmail.com">Get in Touch</Button>;

export default ContactButton;
